(() => {
  'use strict';

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const showToast = (message, duration = 3200) => {
    const toast = document.querySelector('[data-site-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timeout);
    showToast.timeout = window.setTimeout(() => toast.classList.remove('is-visible'), duration);
  };

  window.BrandBadgerTheme = window.BrandBadgerTheme || {};
  window.BrandBadgerTheme.showToast = showToast;

function bindMobileNav(details,document,window) {
  if(details.dataset.keyboardReady)return;
  details.dataset.keyboardReady='true';
  const summary=details.querySelector('summary');
  const close=returnFocus=>{
    details.open=false;
    document.body.classList.remove('menu-open');
    summary?.setAttribute('aria-label','Open menu');
    if(returnFocus&&summary?.getClientRects().length)summary.focus();
  };
  const focusable=()=>Array.from(details.querySelectorAll('summary,a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]'))
    .filter(el=>el.tabIndex>=0&&el.getClientRects().length&&!el.closest('[inert]'));
  details.addEventListener('keydown',event=>{
    if(!details.open)return;
    if(event.key==='Escape'){event.preventDefault();close(true);return;}
    if(event.key!=='Tab')return;
    const items=focusable();
    const first=items[0],last=items.at(-1);
    if(!first){event.preventDefault();return;}
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  });
  // If pointer/programmatic focus leaves the overlay, close it before exposing page controls.
  document.addEventListener('focusin',event=>{
    if(details.isConnected&&details.open&&!details.contains(event.target))close(false);
  });
  window.addEventListener('resize',()=>{
    if(details.isConnected&&details.open&&!summary?.getClientRects().length)close(false);
  });
}

  const initMobileNav = (root = document) => {
    root.querySelectorAll('[data-mobile-nav]').forEach((details) => {
      if (details.dataset.initialized) return;
      details.dataset.initialized = 'true';
      bindMobileNav(details, document, window);
      details.addEventListener('toggle', () => {
        document.body.classList.toggle('menu-open', details.open);
        const summary = details.querySelector('summary');
        summary?.setAttribute('aria-label', details.open ? 'Close menu' : 'Open menu');
      });
      details.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          details.open = false;
        });
      });
    });
  };

  const initHeaderSearch = (root = document) => {
    root.querySelectorAll('[data-header-search]').forEach((details) => {
      if (details.dataset.initialized) return;
      details.dataset.initialized = 'true';
      details.addEventListener('toggle', () => {
        if (details.open) window.setTimeout(() => details.querySelector('input')?.focus(), 0);
      });
      document.addEventListener('click', (event) => {
        if (details.open && !details.contains(event.target)) details.open = false;
      });
    });
  };

  const initHeroBadge = (root = document) => {
    root.querySelectorAll('[data-hero-badge-stage]').forEach((stage) => {
      if (stage.dataset.initialized) return;
      stage.dataset.initialized = 'true';
      const badge = stage.querySelector('[data-hero-badge]');
      if (!badge) return;

      let active = false;
      let startX = 0;
      let startY = 0;
      let rotateX = 58;
      let rotateZ = -8;
      let originX = rotateX;
      let originZ = rotateZ;

      const render = () => {
        badge.style.setProperty('--rotate-x', `${rotateX}deg`);
        badge.style.setProperty('--rotate-z', `${rotateZ}deg`);
      };

      badge.addEventListener('pointerdown', (event) => {
        active = true;
        startX = event.clientX;
        startY = event.clientY;
        originX = rotateX;
        originZ = rotateZ;
        badge.setPointerCapture(event.pointerId);
      });

      badge.addEventListener('pointermove', (event) => {
        if (!active) return;
        rotateZ = clamp(originZ + (event.clientX - startX) * 0.16, -28, 28);
        rotateX = clamp(originX - (event.clientY - startY) * 0.13, 30, 78);
        render();
      });

      const release = (event) => {
        if (!active) return;
        active = false;
        if (badge.hasPointerCapture(event.pointerId)) badge.releasePointerCapture(event.pointerId);
      };

      badge.addEventListener('pointerup', release);
      badge.addEventListener('pointercancel', release);
    });
  };

  const initProductForms = (root = document) => {
    root.querySelectorAll('[data-product-form]').forEach((form) => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      form.addEventListener('submit', async (event) => {
        if (!window.fetch || !window.BrandBadgerTheme?.routes?.cartAdd) return;
        event.preventDefault();
        const button = form.querySelector('[type="submit"]');
        const original = button?.textContent;
        if (button) {
          button.disabled = true;
          button.textContent = 'Adding…';
        }
        try {
          const response = await fetch(window.BrandBadgerTheme.routes.cartAdd, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || 'Unable to add this item.');
          const count = document.querySelector('[data-cart-count]');
          if (count) {
            const nextCount = Number(count.textContent || 0) + Number(payload.quantity || 1);
            count.textContent = String(nextCount);
            document.querySelectorAll('.cart-link').forEach((link) => {
              link.setAttribute('aria-label', `Cart with ${nextCount} ${nextCount === 1 ? 'item' : 'items'}`);
            });
          }
          showToast('Added to your cart.');
        } catch (error) {
          showToast(error.message || 'Unable to add this item.');
        } finally {
          if (button) {
            button.disabled = false;
            button.textContent = original;
          }
        }
      });
    });
  };

  const init = (root = document) => {
    initMobileNav(root);
    initHeaderSearch(root);
    initHeroBadge(root);
    initProductForms(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();


/* Brand Badger preview improvements: sample artwork never enters order data. */
(() => {
  const asset = Array.from(document.scripts).find(script => script.src.includes('/theme.js'));
  let sample = null;
  const refresh = () => document.querySelectorAll('brand-badge-configurator').forEach(el => {
    if (!el.state) return;
    el.updateSummary();
    el.scheduleModelRebuild();
    if(el.camera&&el.controls) el.setView('iso',false);
  });
  const logoReady = asset ? fetch(new URL('brand-badger-primary.svg', asset.src)).then(response => {
    if (!response.ok) throw new Error('Example logo unavailable');
    return response.text();
  }).then(text => {
    const doc = new DOMParser().parseFromString(text, 'image/svg+xml');
    const root = doc.documentElement;
    const children = Array.from(root.children);
    const mascot = children[0].cloneNode(true);
    mascot.querySelectorAll('[fill="#F7F2E8"]').forEach(node => node.remove());
    const serialize = node => new XMLSerializer().serializeToString(node);
    const letters = children.slice(1, 12).map(serialize).join('');
    const motto = children.slice(13).map(serialize).join('');
    sample = {
      mascot: '<svg xmlns="http://www.w3.org/2000/svg">' + serialize(mascot) + '</svg>',
      letters: '<svg xmlns="http://www.w3.org/2000/svg">' + letters + '</svg>'
    };
  }).catch(() => {}) : Promise.resolve();
  customElements.whenDefined('brand-badge-configurator').then(() => {
    const proto = customElements.get('brand-badge-configurator').prototype;
    if (proto.brandBadgerPreviewEnhanced) return;
    proto.brandBadgerPreviewEnhanced = true;
    const isSample = el => !el.artwork && !['companyName','phone','website'].some(key => String(el.state?.[key] || '').trim());
    const originalArtwork = proto.createArtworkGroup;
    proto.createArtworkGroup = function () {
      const group = new this.badgeRoot.constructor();
      const {width,height,baseDepth,raisedDepth,cornerRadius} = this.manufacturing;
      const top = this.baseMesh.material.clone();
      top.color.set(this.state.raisedColor);
      top.roughness=0.48;
      const side=top.clone();side.color.multiplyScalar(0.48);side.roughness=0.72;
      const relief=[top,side];
      const z=baseDepth/2;
      const outline=this.baseMesh.geometry.parameters.shapes.clone();
      outline.holes=[];
      const hole=new outline.constructor();
      const hw=width/2-1.2,hh=height/2-1.2,ir=Math.max(0.1,cornerRadius-1.2);
      hole.moveTo(-hw+ir,-hh);hole.quadraticCurveTo(-hw,-hh,-hw,-hh+ir);hole.lineTo(-hw,hh-ir);hole.quadraticCurveTo(-hw,hh,-hw+ir,hh);hole.lineTo(hw-ir,hh);hole.quadraticCurveTo(hw,hh,hw,hh-ir);hole.lineTo(hw,-hh+ir);hole.quadraticCurveTo(hw,-hh,hw-ir,-hh);hole.closePath();
      outline.holes.push(hole);
      const ringGeometry=new this.baseMesh.geometry.constructor(outline,{depth:raisedDepth,steps:1,curveSegments:12,bevelEnabled:false});
      const ring=new this.baseMesh.constructor(ringGeometry,relief);ring.position.z=z;ring.name='Raised border flush with outside edge';ring.material=top.clone();ring.material.side=2;group.add(ring);
      if (!sample || !isSample(this)) {
        const customer=originalArtwork.call(this);
        customer.position.z=-0.01;
        group.add(customer);
        return group;
      }
      group.name='Brand Badger example — preview only';
      group.add(this.createSvgArtwork(sample.mascot,relief,{maxWidth:width*0.33,maxHeight:height*0.56,x:-width*0.285,y:height*0.075,z,depth:raisedDepth}));
      group.add(this.createSvgArtwork(sample.letters,relief,{maxWidth:width*0.47,maxHeight:height*0.25,x:width*0.205,y:height*0.205,z,depth:raisedDepth}));
      const text=(value,x,y,maxWidth,maxHeight,size)=>group.add(this.createTextMesh(value,relief,{x,y,z,maxWidth,maxHeight,size,depth:raisedDepth}));
      text('LOGO',-width*0.285,-height*0.032,width*0.17,height*0.046,4);
      text('HERE',-width*0.285,-height*0.099,width*0.17,height*0.046,4);
      text('250-555-0123',width*0.205,-height*0.025,width*0.48,height*0.073,8);
      text('brandbadger.example',width*0.205,-height*0.16,width*0.48,height*0.049,7);
      text('BRAND BETTER',0,-height*0.38,width*0.48,height*0.055,4);
      group.add(this.createSvgArtwork('<svg xmlns="http://www.w3.org/2000/svg"><path d="M0 0H100V0.5H0Z"/></svg>',relief,{maxWidth:width*0.84,maxHeight:0.35,x:0,y:-height*0.28,z,depth:raisedDepth}));
      group.traverse(object=>{object.userData.previewOnly=true;object.castShadow=false;object.receiveShadow=false;});
      return group;
    };
    const originalResize = proto.resizeRenderer;
    proto.resizeRenderer = function () {
      originalResize.call(this);
      if (this.camera) {
        this.camera.zoom=Math.min(1.35,Math.max(0.72,this.camera.aspect*0.82));
        this.camera.updateProjectionMatrix();
        this.requestRender();
      }
    };
    const originalRender = proto.requestRender;
    proto.requestRender = function (...args) {
      if (this.renderer) this.renderer.shadowMap.enabled=false;
      if(this.canvasWrap){this.canvasWrap.style.background='radial-gradient(ellipse at center, #91A4B2 0%, #5E7181 100%)';this.canvasWrap.style.color='#F5F5F2';}
      const meta=this.querySelector('.configurator-canvas-meta');if(meta)meta.style.color='#F5F5F2';
      this.scene?.traverse(object => {
        object.castShadow=false;
        object.receiveShadow=false;
        if (object.material?.isShadowMaterial) object.visible=false;
      });
      return originalRender.apply(this,args);
    };
    const originalView=proto.setView;
    proto.setView=function(view,animate=true){
      if(view==='iso'){
        originalView.call(this,'iso',false);
        const distance=Math.max(this.manufacturing?.width||114.3,100)*1.55;
        this.camera.position.set(distance*0.22,distance*0.15,distance*1.08);
        this.controls.update();this.requestRender();return;
      }
      if(view!=='edge') return originalView.call(this,view,animate);
      originalView.call(this,'iso',false);
      const distance=Math.max(this.manufacturing.width,100)*1.55;
      this.camera.position.set(distance*0.18,-distance*0.86,distance*0.38);
      this.controls.update();this.requestRender();
      this.querySelectorAll('[data-view]').forEach(button=>{
        const active=button.dataset.view==='edge';
        button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active));
      });
    };
    const originalSummary = proto.updateSummary;
    proto.updateSummary = function () {
      originalSummary.call(this);
      const views=this.querySelector('.view-controls');
      if(views&&!views.querySelector('[data-view="edge"]')){
        const button=document.createElement('button');button.type='button';button.className='view-control';button.dataset.view='edge';button.textContent='Edge';button.setAttribute('aria-pressed','false');button.addEventListener('click',()=>this.setView('edge'));views.append(button);
      }
      const dimension=this.querySelector('[data-dimension-label]');
      if(dimension) dimension.textContent='4.5″ W × 2.45″ H × 0.08″ finished • 114.3 × 62.23 × 2.032 mm';
      const note=this.querySelector('[data-preview-note]');
      if (note) note.textContent=isSample(this)
        ? 'Example contacts shown. Raised lettering and edge border: 0.6 mm above a 1.432 mm base (layer split awaiting confirmation). Use Edge to inspect the relief.'
        : 'Your design preview. Screen colours and geometry are approximate; a reviewed production proof follows before manufacturing.';
    };
    proto.goToStep = function (targetStep) {
      this.currentStep=Math.min(Math.max(targetStep,1),4);
      this.setStatus('');this.updateStepUI();
      this.scrollIntoView({behavior:'smooth',block:'start'});
      this.querySelector('[data-step="'+this.currentStep+'"] .configurator-step__heading')?.focus({preventScroll:true});
    };
    logoReady.then(refresh);
  });
})();

/* Brand Badger PETG draft review v1 — trial limits require print validation. */
(() => {
  customElements.whenDefined('brand-badge-configurator').then(() => {
    const p=customElements.get('brand-badge-configurator').prototype;
    if(p.bbPetgReviewInstalled)return;p.bbPetgReviewInstalled=true;
    const profile={id:'p1s-petg-04-trial-1',material:'PETG',nozzleMm:0.4,layerHeightMm:0.2,minimumCapHeightMm:3,minimumRaisedStrokeMm:0.8,minimumNegativeGapMm:0.6,minimumBorderClearanceMm:1,status:'requires-print-validation',fontId:'helvetiker-regular',fontQualified:false};
    const makeText=p.createTextMesh;
    p.createTextMesh=function(text,material,options){
      const adjusted={...options};if(adjusted.size===2.6)adjusted.size=3.4;
      const mesh=makeText.call(this,text,material,adjusted);
      const reference=makeText.call(this,'H',material,{...adjusted,maxWidth:10000,maxHeight:10000});
      const raw=makeText.call(this,text,material,{...adjusted,maxWidth:10000,maxHeight:10000});
      const box=mesh.geometry.boundingBox,rb=raw.geometry.boundingBox,hb=reference.geometry.boundingBox;
      const scale=Math.min(1,(box.max.x-box.min.x)/Math.max(0.001,rb.max.x-rb.min.x),(box.max.y-box.min.y)/Math.max(0.001,rb.max.y-rb.min.y));
      mesh.userData.bbText={text,capHeightMm:(hb.max.y-hb.min.y)*scale,unsupported:[...text].filter(c=>!this.font.data.glyphs[c])};
      reference.geometry.dispose();raw.geometry.dispose();return mesh;
    };
    p.bbReview=function(){
      const lines=[];const visit=(o,skip=false)=>{skip=skip||!!o.userData?.previewOnly;if(!skip&&o.userData?.bbText)lines.push({...o.userData.bbText});o.children?.forEach(c=>visit(c,skip));};
      if(this.artworkGroup)visit(this.artworkGroup);
      const issues=lines.filter(l=>!Number.isFinite(l.capHeightMm)||l.capHeightMm<2.999999||l.unsupported.length);
      this.bbManufacturingReview={profile,lines,issues,status:'manual-review-required',unchecked:['stroke-width','logo-gaps','border-clearance','hardware-clearance','physical-print-test']};
      let panel=this.querySelector('[data-bb-petg-review]');
      if(!panel){panel=document.createElement('div');panel.dataset.bbPetgReview='';panel.className='bb-print-review';panel.setAttribute('aria-live','polite');this.querySelector('[data-step="1"]')?.append(panel);}
      panel.replaceChildren();const title=document.createElement('strong');title.textContent=issues.length?'Lettering needs adjustment':'Lettering size review';panel.append(title);
      const help=document.createElement('p');help.textContent=lines.length?'Trial minimum: 3 mm capital-letter height. Shorten any text flagged below.':'Enter your details to check the finished lettering size.';panel.append(help);
      for(const l of lines){const row=document.createElement('p');row.className='bb-print-review__line'+(issues.includes(l)?' is-error':'');row.textContent=l.text+' — '+l.capHeightMm.toFixed(2)+' mm'+(l.unsupported.length?' · Unsupported characters':l.capHeightMm<2.999999?' · Too small':'');panel.append(row);}
      const note=document.createElement('small');note.textContent='PETG badge · Artwork review required. Logo details, font strokes and spacing require manual proof review.';panel.append(note);
    };
    const rebuild=p.rebuildModel;p.rebuildModel=async function(...args){await rebuild.apply(this,args);this.bbReview();};
    for(const name of ['exportProductionPackage','submitDesign']){const original=p[name];p[name]=async function(...args){args[0]?.preventDefault?.();this.updateStateFromControls();await this.flushModelRebuild();this.bbReview();if(this.bbManufacturingReview.issues.length){this.setStatus('Some lettering is too small or contains unsupported characters. Review the lettering sizes in Artwork.',true);this.goToStep(1);this.setStatus('Shorten the flagged text to meet the trial 3 mm minimum letter height.',true);return;}return original.apply(this,args);};}
    const validate=p.validateStep;p.validateStep=function(step){if(!validate.call(this,step))return false;if(step===1){this.bbReview();if(this.bbManufacturingReview.issues.length){this.setStatus('Shorten the flagged text to meet the trial 3 mm minimum letter height.',true);return false;}}return true;};
    const go=p.goToStep;p.goToStep=function(target){if(target>1&&this.currentStep===1&&this.bbManufacturingReview?.issues.length){this.setStatus('Shorten the flagged text to meet the trial 3 mm minimum letter height.',true);return;}return go.call(this,target);};
    const view=p.setView;p.setView=function(name,...args){const result=view.call(this,name,...args);if(name==='edge'&&this.camera){this.camera.position.multiplyScalar(1.18);this.controls.update();this.requestRender();}return result;};
    const record=p.buildRecord;p.buildRecord=function(...args){const result=record.apply(this,args);result.manufacturingReview=this.bbManufacturingReview||null;return result;};
    const summary=p.updateSummary;p.updateSummary=function(...args){const result=summary.apply(this,args);const note=this.querySelector('[data-preview-note]');if(note&&note.textContent.startsWith('Example contacts'))note.textContent='Example design and contact details. Use Edge to inspect the raised lettering. A reviewed production proof confirms your final design.';return result;};
    const steps=p.updateStepUI;p.updateStepUI=function(...args){const result=steps.apply(this,args);this.querySelectorAll('[data-progress-step]').forEach(b=>{b.classList.remove('is-complete');const n=b.querySelector('[data-progress-number]');if(n)n.textContent=b.dataset.progressStep;});return result;};
    document.querySelectorAll('brand-badge-configurator').forEach(el=>{if(el.state){el.updateStepUI();el.scheduleModelRebuild();}});
  });
})();
